import React from 'react';
import { IButton } from './types';

const Button: React.FC<IButton> = ({ type }) => {
  return (
    <button
      className="DateRangePickerInput_calendarIcon DateRangePickerInput_calendarIcon_1"
      type="button"
      aria-label="Interact with the calendar and add the check-in date for your trip."
      style={type === 'calendar' ? { top: 'calc(50% - 11px)' } : {}}
    >
      <i className="material-icons notranslate">&#xe24f;</i>
    </button>
  );
};

export default Button;
